const interfacecfg = {
  colors: {
    navigation: 'grey darken-2',
    appbar: 'white',
    footer: 'grey darken-3',
    loading: 'grey darken-4',
    toolbar: 'white',
    loginbg: 'grey darken-2',
    neworder: 'primary',
    confirm: {
      true: 'green'
    }
  },
  loading: false,
  login_loading: false,
  overlay: false,
  blocked: false,
  snackbar: {
    active: false,
    message: '',
    color: ''
  },
  is_mobile: false,
  update_interval: 7777,
  devtools: true
}

export default interfacecfg
